<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              :label="$t('Type')"
              :invalid-feedback="$t('Type is required')"
            >
              <v-select
                v-model="myObj.homework.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="typeOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                label="text"
                :placeholder="$t('Select Type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Title')"
              :invalid-feedback="$t('Title is required')"
            >
              <b-form-input
                :placeholder="$t('Enter title')"
                ref="title"
                v-model.trim="myObj.homework.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Class')"
              :invalid-feedback="$t('Class is required')"
              ref="class"
            >
              <v-select
                ref="class"
                v-model="myObj.homework.cID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :reduce="(val) => val.id"
                :clearable="false"
                label="name"
                @input="FillSections()"
                :placeholder="$t('Select class')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Section')"
              :invalid-feedback="$t('Section is required')"
              ref="section"
            >
              <v-select
                v-if="myObj.editIDs.length === 0"
                multiple
                :closeOnSelect="false"
                ref="section"
                v-model="secIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { section: 'All Sections', id: 0 },
                  ...currentSections,
                ]"
                :reduce="(val) => val.id"
                :clearable="false"
                label="section"
                @input="setSections()"
                :placeholder="$t('Select sections')"
              />
              <v-select
                v-else
                ref="section"
                :key="'edit-section-' + currentSectionId"
                v-model="currentSectionId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="currentSections"
                :reduce="(val) => val.id"
                :clearable="false"
                label="section"
                :placeholder="$t('Select section')"
                @input="handleEditSectionChange"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Subject')"
              :invalid-feedback="$t('Subject is required')"
              ref="sub"
            >
              <v-select
                ref="sub"
                v-model="myObj.homework.subID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="subjects"
                :reduce="(val) => val.id"
                :clearable="false"
                label="subject"
                :placeholder="$t('Select subject')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Details')"
              :invalid-feedback="$t('Details is required')"
              ref="detail"
            >
              <b-form-textarea
                ref="detail"
                :placeholder="$t('Enter Details')"
                v-model="myObj.homework.details"
                @focusout="checkDetails()"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="date"
            >
              <flat-pickr
                :config="activeConfig"
                v-model="myObj.homework.date"
                class="form-control"
                :placeholder="$t('Select date')"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label=""
              :invalid-feedback="$t('Documents are required')"
              required
              ref="docs"
            >
              <b-button
                @click="$refs.mediaDoc.click()"
                variant="primary"
                :disabled="request || mydocloading || publishing"
                block
              >
                <b-spinner
                  v-if="mydocloading"
                  type="grow"
                  small
                  label="Loading..."
                />
                <span v-else>{{ $t("Upload Attachments") }}</span>
              </b-button>
              <input
                type="file"
                id="mediaDoc"
                hidden
                ref="mediaDoc"
                multiple
                accept="image/*,video/*,application/pdf"
                @change="addMedia()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="d-flex flex-wrap">
            <div
              class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
              style="width: 80px; height: 80px; position: relative"
              v-for="(file, index) in attachments"
              :key="index"
              @click="openFile(file.url)"
            >
              <b-img
                v-if="file.type.toLowerCase() === 'image'"
                :src="getMediaPreviewUrl(file.url, file.type)"
                alt=""
                referrerpolicy="no-referrer"
                class="w-100 h-100 rounded"
                style="object-fit: cover"
                @error="onMediaPreviewError($event, file)"
              />
              <video
                v-else-if="file.type.toLowerCase() === 'video'"
                :src="file.url"
                class="w-100 h-100 rounded"
                preload="metadata"
                style="object-fit: contain"
              />
              <feather-icon
                v-else
                :icon="getFileIcon(file.type)"
                size="30"
                class="text-primary"
              />
              <b-avatar
                size="20"
                variant="primary"
                style="position: absolute; top: -5px; right: -5px"
                button
                @click.stop="removeMedia(index)"
              >
                <feather-icon icon="XIcon" />
              </b-avatar>
            </div>
          </b-col>

          <!-- <b-col cols="12">
            <div>
              <b-badge
                style="margin-bottom: 5px"
                class="p-1"
                v-for="(file, index) in attachments"
                :key="index"
                variant="light-primary"
              >
                <a :href="file.url" target="_blank" class="text-primary">
                  {{ index + 1 + " : " + file.url.slice(0, 40) }}
                </a>

                <i
                  class="text-danger fa fa-trash"
                  style="cursor: pointer"
                  @click="removeMedia(index)"
                ></i>
              </b-badge>
            </div>
          </b-col> -->

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="Add(false)"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
          <b-col md="12" class="mt-1" v-if="!isPublished">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="info"
              @click="Add(true)"
              :disabled="request || publishing"
              block
            >
              <b-spinner v-if="publishing" small type="grow" />
              <span v-else>{{ $t("Save & Publish") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <!-- <b-row>
          <b-col md="7">
            <b-form-group label="Title " invalid-feedback="Title is required">
              <b-form-input
                placeholder="Enter tile."
                ref="title"
                v-model="myObj.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
  
            <b-form-group
              label="Message"
              invalid-feedback="Messgae is required."
              ref="msg"
            >
              <b-form-textarea
                ref="msg"
                placeholder="Enter message."
                v-model="myObj.message"
                @focusout="CheckMessage()"
                rows="5"
              ></b-form-textarea>
            </b-form-group>
  
            <div class="text-right">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                :disabled="request"
                @click="Add()"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-if="request == false"> Save </span>
              </b-button>
            </div>
          </b-col>
          <b-col md="5">
            <b-row>
              <b-col md="12">
                <b-input-group class="input-group-merge w-100">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" class="text-muted" />
                  </b-input-group-prepend>
                  <b-form-input v-model="searchQuery" :placeholder="$t('Search') + '...'" />
                </b-input-group>
              </b-col>
  
              <b-col
                md="12"
                class="mt-1"
                style="display: flex; cursor: context-menu"
                v-for="item in items"
                :key="item.id"
                @click="Edit(item.id)"
              >
                <b-avatar class="mb-1" variant="light-primary" size="35">
                  <span style="font-size: 20px">{{
                    item.title.substring(0, 1)
                  }}</span>
                </b-avatar>
                <div class="" style="margin-left: 5px">
                  <h4 class="font-weight-bolder mb-0" style="margin-top: 5px">
                    {{ item.title.substring(1) }}
                  </h4>
                  <p style="max-height: 1.5em; overflow: hidden">
                    {{ item.message }}
                  </p>
                </div>
              </b-col>
          
            </b-row>
          </b-col>
        </b-row> -->

      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" v-if="rights.add">
          <b-button
            class="mb-1 mb-xl-0"
            @click="AddOpen()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Homework") }}</span>
          </b-button>
        </b-col>
        <b-col xl="10" lg="9" md="8">
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            label=""
            :invalid-feedback="$t('Class is required')"
            ref="fil_type"
          >
            <v-select
              v-model="filterObj.type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="typeOptions"
              :reduce="(val) => val.value"
              :clearable="false"
              label="text"
              :placeholder="$t('Select Type')"
              @input="LoadData()"
            />
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            label=""
            :invalid-feedback="$t('Class is required')"
            ref="fil_class"
          >
            <v-select
              ref="fil_class"
              v-model="filterObj.clsID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ name: 'All Classes', id: 0 }, ...classesOptions]"
              :reduce="(val) => val.id"
              :clearable="false"
              label="name"
              @input="loadSections()"
              :placeholder="$t('Select class')"
            />
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            label=""
            :invalid-feedback="$t('Section is required')"
            ref="fil_sec"
          >
            <v-select
              ref="fil_sec"
              v-model="filterObj.secID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ section: 'All Sections', id: 0 }, ...filterSections]"
              :reduce="(val) => val.id"
              :clearable="false"
              label="section"
              :placeholder="$t('Select sections')"
              @input="LoadData()"
            />
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            label=""
            :invalid-feedback="$t('Date is required')"
            ref="fil_date"
          >
            <flat-pickr
              ref="fil_date"
              v-model="rangeDate"
              :config="config2"
              class="form-control"
              :placeholder="$t('Select date')"
              @on-change="setDate"
            />
          </b-form-group>
        </b-col>
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            label=""
            :invalid-feedback="$t('Subject is required')"
            ref="fil_sub"
          >
            <v-select
              v-model="filterObj.subjectID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ subject: 'All Subjects', id: 0 }, ...subjects]"
              :reduce="(val) => val.id"
              :clearable="false"
              label="subject"
              :placeholder="$t('Select subject')"
              @input="LoadData()"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col xl="2" lg="3" md="4" sm="6">
          <b-button
            @click="showReport()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Report") }}</span>
          </b-button>
        </b-col> -->
      </b-row>

      <b-row v-if="selectedIDs.length > 0">
        <b-col md="12" class="text-right">
          <b-button
            @click="publishSelected()"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            :disabled="bulkPublishing"
          >
            <b-spinner v-if="bulkPublishing" small class="mr-50" />
            <span class="align-middle"
              >{{ $t("Publish") }} ({{ selectedIDs.length }})</span
            >
          </b-button>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :busy="dataLoading"
        show-empty
        responsive
        hover
        small
        @row-clicked="onRowSelect"
      >
        <!-- @row-selected="Edit($event[0])" -->
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
        </template>
        <template #table-busy>
          <div
            class="d-flex justify-content-center mb-3"
            style="margin-top: 50px"
          >
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <template #head(title)="data">
          <div>
            <b-form-checkbox
              v-if="!isMyskoolProfectus"
              inline
              :checked="
                selectedIDs.length > 0 && selectedIDs.length == items.length
              "
              :disabled="bulkPublishing"
              @change="(e) => setSelectAll(e)"
            >
              <span class="font-small-2">{{ $t(data.label) }}</span>
            </b-form-checkbox>
            <span v-else class="font-small-2">{{ $t(data.label) }}</span>
          </div>
        </template>

        <template #head(actions)="data">
          <div class="mr-5 text-right">
            <span>{{ $t(data.label) }}</span>
          </div>
        </template>

        <template #cell(title)="data">
          <b-form-checkbox
            v-if="!isMyskoolProfectus"
            inline
            :checked="selectedIDs.includes(data.item.data.id)"
            :disabled="bulkPublishing"
            @change="(e) => setSelected(e, data.item.data.id)"
          >
            <span>{{ data.item.data.title }}</span>
          </b-form-checkbox>
          <span v-else>{{ data.item.data.title }}</span>
          <br v-if="!isMyskoolProfectus" />
          <b-badge
            v-if="data.item.attachments.length > 0"
            variant="light-warning"
            class="mt-50"
            @click.stop="rights.edit ? Edit(data.item) : null"
          >
            {{ data.item.attachments.length }} {{ $t("Attachments") }}
          </b-badge>
        </template>
        <template #cell(details)="data">
          {{ data.item.data.details }}
        </template>

        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.data.date).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
          <br v-if="!isMyskoolProfectus" />
          <b-badge
            v-if="!isMyskoolProfectus && data.item.data.isPublished"
            variant="light-success"
            class="mt-50"
          >
            {{ $t("Published") }}
          </b-badge>
          <b-badge
            v-else-if="!isMyskoolProfectus"
            variant="light-danger"
            class="mt-50"
          >
            {{ $t("Unpublished") }}
          </b-badge>
        </template>

        <template #cell(class)="data">
          <b-badge variant="light-primary">
            <!-- {{ getClassName(data.item.cID) }} -->
            {{ data.item.data.clsName }}
          </b-badge>
        </template>
        <template #cell(section)="data">
          <b-badge variant="light-primary">
            <!-- {{ getSecName(data.item.cID, data.item.section) }} -->
            {{ data.item.data.section }}
          </b-badge>
        </template>
        <template #cell(subject)="data">
          <b-badge variant="light-primary">
            <!-- {{ getSubName(data.item.subID) }} -->
            {{ data.item.data.subject }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <div class="d-flex text-center">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-50"
              @click.stop="Edit(data.item)"
              :disabled="editLoading"
            >
              <b-spinner
                v-if="editLoading && currentID == data.item.data.id"
                variant="light"
                small
              ></b-spinner>
              <feather-icon v-else icon="EditIcon" class="" />
            </b-button>
            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon mr-50"
              @click.stop="Delete(data.item.data.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.right
              :title="$t('Send Message')"
              class="btn-icon"
              @click.stop="openMessagePopup(data.item)"
            >
              <feather-icon icon="MessageSquareIcon" />
            </b-button>
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-success"
              v-b-tooltip.hover.right
              :title="$t('Mark Status')"
              class="btn-icon ml-50"
              :disabled="statusListLoading"
              @click.stop="openStatus(data.item)"
            >
              <b-spinner
                v-if="statusListLoading && currentHwID == data.item.data.id"
                variant="success"
                small
              />
              <feather-icon v-else icon="CheckCircleIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>

    <!-- Message Popup -->
    <b-modal
      v-model="messageModal"
      :title="$t('Send Message')"
      size="lg"
      hide-footer
      centered
    >
      <b-form @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('Select Students')"
              :invalid-feedback="$t('Please select students')"
              ref="students"
            >
              <v-select
                multiple
                :filterBy="dropFilter"
                :closeOnSelect="false"
                v-model="selectedStudents"
                :disabled="loadingStudents || sendingMessage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="studentList"
                :clearable="false"
                :placeholder="$t('Select Students')"
                label="name"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-flex align-items-center">
                    <b-avatar
                      v-if="option.picture"
                      size="30"
                      :src="option.picture"
                      class="badge-minimal"
                      variant="transparent"
                    />
                    <b-avatar
                      v-else
                      size="30"
                      src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                      class="badge-minimal"
                      variant="transparent"
                    />
                    <div class="chat-info flex-grow-1 ml-1">
                      <h5 class="mb-0">
                        {{ option.name }}
                      </h5>
                      <p class="card-text text-truncate">
                        GRN - {{ option.grNo }}
                      </p>
                    </div>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('Message')">
              <b-form-textarea
                v-model.trim="messageText"
                rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12" class="text-right">
            <b-button
              variant="primary"
              :disabled="sendingMessage"
              @click="sendMessage"
            >
              <b-spinner v-if="sendingMessage" small variant="light" />
              <span v-else>{{ $t("Send") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Homework Status Modal -->
    <b-modal
      v-model="statusModal"
      :title="$t('Homework Status')"
      size="lg"
      hide-footer
      centered
    >
      <div v-if="statusHomeworkItem" class="mb-1 p-1 bg-light rounded border">
        <b-row class="font-small-3">
          <b-col md="4" class="mb-25">
            <span class="text-muted">{{ $t("Title") }}:</span>
            <div class="font-weight-bold text-dark">
              {{ statusHomeworkItem.title }}
            </div>
          </b-col>
          <b-col md="4" class="mb-25">
            <span class="text-muted">{{ $t("Class / Section") }}:</span>
            <div class="font-weight-bold text-dark">
              {{ statusHomeworkItem.clsName }} -
              {{ statusHomeworkItem.section }}
            </div>
          </b-col>
          <b-col md="4" class="mb-25">
            <span class="text-muted">{{ $t("Date") }}:</span>
            <div class="font-weight-bold text-dark">
              {{
                new Date(statusHomeworkItem.date).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </div>
          </b-col>
          <b-col md="12">
            <span class="text-muted">{{ $t("Details") }}:</span>
            <div class="text-dark" style="white-space: pre-wrap">
              {{ statusHomeworkItem.details }}
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="statusList"
        :fields="statusFields"
        :busy="statusListLoading"
        sticky-header="350px"
        show-empty
        responsive
        small
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
        </template>
        <template #table-busy>
          <div
            class="d-flex justify-content-center mb-3"
            style="margin-top: 50px"
          >
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <template #cell(student)="row">
          <div class="d-flex align-items-center">
            <b-avatar
              size="40"
              :src="
                row.item.picture ||
                'https://cdn.cloudious.net/file-1677912450367-333289208.png'
              "
              class="mr-1"
              variant="transparent"
            />
            <div class="d-flex flex-column align-items-start">
              <span class="font-weight-bolder text-dark">{{
                row.item.name
              }}</span>
              <b-badge
                variant="light-primary"
                class="mt-25 font-small-2"
                v-if="row.item.father_name"
              >
                F/N - {{ row.item.father_name }}
              </b-badge>
              <b-badge variant="light-primary" class="mt-25 font-small-2">
                GR - {{ row.item.grNo }}
              </b-badge>
            </div>
          </div>
        </template>

        <template #cell(status)="row">
          <b-input-group>
            <b-form-input
              style="width: 120px"
              placeholder="Select status"
              disabled
              v-model="row.item.homeworkStatus.status"
            />
            <b-input-group-append>
              <b-dropdown
                :disabled="reportLoading"
                toggle-class="btn-icon p-25"
                variant="outline-secondary"
                class="remarks-dropdown"
                size="sm"
                right
                no-caret
              >
                <template #button-content>
                  <feather-icon icon="ChevronDownIcon" size="16" />
                </template>
                <b-dropdown-item
                  v-for="(st, stIndex) in statusOptions"
                  :key="stIndex"
                  :active="row.item.homeworkStatus.status == st.value"
                  @click="row.item.homeworkStatus.status = st.value"
                  link-class="py-50"
                >
                  {{ st.text }}
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </template>

        <template #cell(remarks)="row">
          <b-form-textarea
            v-if="row.item.homeworkStatus"
            v-model="row.item.homeworkStatus.remarks"
            rows="2"
            :placeholder="$t('Enter remarks')"
          />
        </template>
      </b-table>

      <div class="text-right mt-1">
        <b-button
          variant="success"
          @click="saveHomeworkStatus(false)"
          :disabled="savingStatus || statusListLoading || msgSending"
        >
          <b-spinner v-if="savingStatus && !msgSending" small class="mr-50" />
          {{ $t("Save") }}
        </b-button>
        <b-button
          class="ml-1"
          variant="success"
          @click="saveHomeworkStatus(true)"
          :disabled="savingStatus || statusListLoading || msgSending"
        >
          <b-spinner v-if="msgSending" small class="mr-50" />
          {{ $t("Save & Send Message") }}
        </b-button>
        <b-button
          variant="outline-secondary"
          class="ml-1"
          @click="closeStatusModal"
          :disabled="savingStatus"
        >
          {{ $t("Cancel") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BAvatar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import {
  buildUploadedAttachment,
  getMediaPreviewUrl as resolveMediaPreviewUrl,
  getUploadedMediaType,
  handleDrivePreviewError,
  normalizeAttachmentRecord,
  uploadToMySkool,
} from "@/utils/gdriveUpload";

export default {
  components: {
    BAvatar,
    BFormTextarea,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BForm,
    BImg,
    BSpinner,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      const dt = new Date().toJSON().split("T")[0];
      this.filterObj.date = dt;
      this.filterObj.dateTill = dt;
      this.rangeDate = `${dt} to ${dt}`;

      this.loadInfo();
      this.LoadData();
    }
    // for dev
    // this.rights = {
    //   view: true,
    //   add: true,
    //   edit: true,
    //   delete: true,
    // };
    // this.loadInfo();
    // this.LoadData();
  },
  computed: {
    isMyskoolProfectus() {
      return this.reportDomain === "myskoolprofectus";
    },
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.data.title.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.data.details.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    activeConfig() {
      return this.config;
    },
  },
  data() {
    return {
      rights: {},
      titleText: "This is title",
      myDepartments: [],
      request: false,
      publishing: false,
      colorDep: [],
      visibility1: false,
      sidebarTitle: "Add Template",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      mydocloading: false,
      errors: {
        status: false,
      },
      index: null,
      fields: [
        { label: "title", key: "title" },
        { label: "date", key: "date" },
        { label: "class", key: "class" },
        { label: "section", key: "section" },
        { label: "subject", key: "subject" },
        { label: "details", key: "details" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      rangeDate: null,
      attachments: [],
      myObj: {
        editIDs: [],
        homework: {
          id: 0,
          subID: 0,
          cID: 0,
          title: "",
          section: 0,
          details: "",
          subject: "",
          date: "",
          savedBy: 0,
          campusID: this.$store.state.userData.cId,
          savedOn: "",
          type: "homework",
          attachments: [
            {
              id: 0,
              hwID: 0,
              name: "",
              type: "",
              url: "",
              fileSize: 0,
            },
          ],
        },
        homeworkAttachment: [
          {
            id: 0,
            hwID: 0,
            name: "",
            type: "",
            url: "",
            fileSize: 0,
          },
        ],
        sections: [],
        db: this.$store.state.userData.db,
      },
      sendOptions: [
        { text: "None", value: "" },
        { text: "Inquiry", value: "Inquiry" },
        { text: "Student Admission", value: "Student Admission" },
        { text: "Fee Collection", value: "Fee Collection" },
        { text: "Defaulters", value: "Defaulters" },
        { text: " Student Attendance (P)", value: " Student Attendance (P)" },
        { text: " Student Attendance (A)", value: " Student Attendance (A)" },
        { text: " Staff Attendance (P)", value: " Staff Attendance (P)" },
        { text: " Staff Attendance (A)", value: " affnt Attendance (A)" },
      ],
      typeOptions: [
        { text: "Homework", value: "homework" },
        { text: "Classwork", value: "classwork" },
      ],
      detailObj: {},
      timeout: 10000,
      mediaLoaded: false,
      docLoading: false,
      classes: [],
      classesOptions: [],
      currentSections: [],
      secIDs: [],
      currentSectionId: null,
      subjects: [],
      filterObj: {
        clsID: 0,
        secID: 0,
        type: "homework",
        date: null,
        dateTill: null,
        subjectID: 0,
      },
      filterSections: [],
      editLoading: false,
      currentID: 0,
      isPublished: false,
      messageModal: false,
      selectedStudents: [],
      studentList: [],
      loadingStudents: false,
      sendingMessage: false,
      messageText: "",
      currentHomework: null,
      selectedIDs: [],
      bulkPublishing: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      statusModal: false,
      statusHomeworkItem: null,
      statusList: [],
      statusListLoading: false,
      currentHwID: 0,
      msgSending: false,
      savingStatus: false,
      statusOptions: [
        { text: "Completed", value: "completed" },
        { text: "Not Completed", value: "not-completed" },
        { text: "Absent", value: "absent" },
      ],
      statusFields: [
        { key: "student", label: "Student" },
        { key: "status", label: "Status" },
        { key: "remarks", label: "Remarks" },
      ],
    };
  },
  validations: {
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      put: "put",
      delete: "delete",
      postObj: "postObj",
    }),

    getClassName(id) {
      let obj = this.classesOptions.find((el) => el.id == id);
      return obj ? obj.name : "-";
    },
    getSubName(id) {
      let obj = this.subjects.find((el) => el.id == id);
      return obj ? obj.subject : "-";
    },
    getSecName(clsID, id) {
      let obj = this.classes.find((el) => el.cls.id == clsID);
      if (obj) {
        let sec = obj.sections.find((el) => el.id == id);
        return sec ? sec.section : "-";
      } else return "-";
    },

    setSelectAll(e) {
      if (e) {
        this.selectedIDs = this.items.map((el) => el.data.id);
      } else {
        this.selectedIDs = [];
      }
    },
    onRowSelect(ch) {
      // console.log(ch);
      if (ch) {
        if (this.selectedIDs.includes(ch.data.id)) {
          this.selectedIDs = this.selectedIDs.filter((el) => el != ch.data.id);
        } else {
          this.selectedIDs.push(ch.data.id);
        }
      }
    },
    setSelected(e, id) {
      if (e) {
        this.selectedIDs.push(id);
      } else {
        this.selectedIDs = this.selectedIDs.filter((el) => el != id);
      }
    },
    async publishSelected() {
      if (!this.selectedIDs.length) return;

      this.bulkPublishing = true;
      try {
        // Fast BulkPublish — publishes/locks immediately; Hangfire sends pushes in background
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Homework/BulkPublish?userID=" +
            this.$store.state.userData.userID,
          body: {
            db: this.$store.state.userData.db,
            homeworkIDs: this.selectedIDs,
          },
          context: this,
          token: this.$store.state.userData.token,
          allResponse: true,
        });

        if (res && String(res.status || "").toLowerCase() === "success") {
          const count =
            Number(res.publishedCount) || this.selectedIDs.length || 0;
          this.$bvToast.toast(
            count === 1
              ? "Homework published successfully."
              : `${count} homework published successfully.`,
            {
              title: this.$t("Success"),
              variant: "success",
              solid: true,
            }
          );
          this.selectedIDs = [];
          this.LoadData();
        } else {
          this.$bvToast.toast(
            (res && (res.message || res.data)) ||
              "Failed to publish homework.",
            {
              title: this.$t("Error"),
              variant: "danger",
              solid: true,
            }
          );
        }
      } catch (error) {
        console.error("Homework BulkPublish error:", error);
        this.$bvToast.toast("Failed to publish homework.", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.bulkPublishing = false;
      }
    },

    showReport() {
      let url =
        `https://${this.reportDomain}.myskool.app/Exams/ShowHomework?` +
        "dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&cls=" +
        this.filterObj.clsID +
        "&sec=" +
        this.filterObj.secID +
        "&type=" +
        this.filterObj.type +
        "&dtFrom=" +
        this.filterObj.date +
        "&dtTo=" +
        this.filterObj.date;

      window.open(url, "_blank");
    },

    loadSections() {
      this.filterObj.secID = 0;
      if (this.filterObj.clsID == 0) {
        this.filterSections = [];
      } else {
        this.filterSections = this.classes.find(
          (el) => el.cls.id == this.filterObj.clsID
        ).sections;
      }
      this.LoadData();
      // console.log(this.filterSections);
    },

    async Edit(item) {
      if (!item) return;
      // console.log("item", item);

      this.editLoading = true;
      this.currentID = item.data.id;

      this.attachments = [];
      this.currentSectionId = null; // Reset section ID
      this.myObj = {
        editIDs: [],
        homework: {},
        homeworkAttachment: [],
        sections: [],
        db: this.$store.state.userData.db,
      };

      var obj = {
        url:
          this.$store.state.domain +
          "Homework/GetSelected?id=" +
          item.data.id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj.homework = await this.get(obj);
      this.isPublished = this.myObj.homework.isPublished;
      this.editLoading = false;
      this.myObj.editIDs = [item.data.id];
      this.attachments = (item.attachments || []).map((att) =>
        normalizeAttachmentRecord(att)
      );
      this.myObj.homeworkAttachment = [...this.attachments];

      console.log("Edit - Full myObj:", this.myObj);
      console.log("Edit - Section ID from API:", this.myObj.homework.section);

      this.visibility = true;

      // Fill sections first based on the class, then set the section ID
      this.FillSections();

      // Use nextTick to ensure sections are populated before setting the selected section
      this.$nextTick(() => {
        // Add a small delay to ensure everything is properly loaded
        setTimeout(() => {
          console.log("=== SECTION SETTING DEBUG ===");
          console.log("Homework section ID:", this.myObj.homework.section);
          console.log(
            "Homework section type:",
            typeof this.myObj.homework.section
          );
          console.log("Available sections:", this.currentSections);
          console.log(
            "Available section IDs:",
            this.currentSections.map((s) => ({
              id: s.id,
              type: typeof s.id,
              name: s.section,
            }))
          );

          // Find the section that matches the homework section ID (using loose equality for type conversion)
          console.log(
            "Searching for section with ID:",
            this.myObj.homework.section
          );
          console.log(
            "In sections:",
            this.currentSections.map((s) => `${s.id} (${typeof s.id})`)
          );

          const matchingSection = this.currentSections.find((sec) => {
            console.log(
              `Comparing: ${sec.id} (${typeof sec.id}) == ${
                this.myObj.homework.section
              } (${typeof this.myObj.homework.section})`
            );
            return sec.id == this.myObj.homework.section;
          });

          console.log("Matching section found:", matchingSection);

          if (matchingSection) {
            this.currentSectionId = matchingSection.id; // Use the actual ID from the found section
            console.log(
              "Successfully set currentSectionId to:",
              this.currentSectionId
            );
            console.log("currentSectionId type:", typeof this.currentSectionId);
          } else {
            console.error(
              "Section not found for ID:",
              this.myObj.homework.section
            );

            // Try with explicit type conversion
            const sectionByStringMatch = this.currentSections.find(
              (sec) =>
                sec.id.toString() === this.myObj.homework.section.toString()
            );

            if (sectionByStringMatch) {
              console.log(
                "Found section by string conversion:",
                sectionByStringMatch
              );
              this.currentSectionId = sectionByStringMatch.id;
            } else {
              console.error("No section match found even with type conversion");
              // Fallback to first section if available
              if (this.currentSections.length > 0) {
                console.log("Using fallback - first section");
                this.currentSectionId = this.currentSections[0].id;
              }
            }
          }

          console.log("Final currentSectionId:", this.currentSectionId);
          console.log("=== END SECTION DEBUG ===");

          // Force re-render by triggering reactivity
          this.$forceUpdate();
        }, 100); // 100ms delay
      });

      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["class"];
      elem.state = undefined;
      var elem = this.$refs["sub"];
      elem.state = undefined;
      var elem = this.$refs["section"];
      elem.state = undefined;
      var elem = this.$refs["date"];
      elem.state = undefined;

      this.sidebarTitle = "Edit Homework";
      this.sidebarButton = "Update";
    },

    AddOpen() {
      this.myObj = {
        editIDs: [],
        homework: {
          id: 0,
          subID: 0,
          cID: 0,
          title: "",
          section: 0,
          details: "",
          subject: "",
          date: new Date().toJSON(),
          savedBy: 0, // for admin
          campusID: this.$store.state.userData.cId,
          savedOn: new Date().toJSON(),
          attachments: [],
          type: "homework",
        },
        homeworkAttachment: [],
        sections: [],
        db: this.$store.state.userData.db,
      };
      this.attachments = [];
      this.secIDs = [];
      this.currentSectionId = null;
      this.isPublished = false;
      this.visibility = true;
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["class"];
      elem.state = undefined;
      var elem = this.$refs["sub"];
      elem.state = undefined;
      var elem = this.$refs["section"];
      elem.state = undefined;

      this.sidebarTitle = "Add Homework";
      this.sidebarButton = "Save";
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.homework.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkDetails() {
      var elem = this.$refs["detail"];
      if (this.myObj.homework.details.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClass() {
      var elem = this.$refs["class"];
      if (this.myObj.homework.cID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSubject() {
      var elem = this.$refs["sub"];
      if (this.myObj.homework.subID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSection() {
      var elem = this.$refs["section"];
      // In edit mode, check currentSectionId, in add mode check secIDs
      if (this.myObj.editIDs.length > 0) {
        if (!this.currentSectionId) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else {
        if (this.secIDs.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      }
    },
    CheckDate() {
      var elem = this.$refs["date"];
      if (!this.myObj.homework.date) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMessage() {
      var elem = this.$refs["msg"];
      if (this.myObj.message == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    },
    isDoc(url) {
      return /\.(pdf)$/.test(url);
    },
    removeMedia(index) {
      this.attachments.splice(index, 1);
      this.myObj.homeworkAttachment = this.attachments;
      // console.log(this.myObj.homeworkAttachment);
    },
    addMedia() {
      let media = this.$refs.mediaDoc.files;
      if (media.length > 0) {
        this.mydocloading = true;
        uploadToMySkool(media)
          .then((resp) => {
            resp.forEach((el) => {
              this.attachments.push(
                buildUploadedAttachment(el, {
                  id: 0,
                  hwID: 0,
                  name: getUploadedMediaType(el),
                })
              );
            });

            this.myObj.homeworkAttachment = this.attachments;
          })
          .catch((e) => {
            console.log(e);
            this.$bvToast.toast("Failed to upload file", {
              title: this.$t("Error"),
              variant: "danger",
              solid: true,
            });
          })
          .finally(() => {
            this.mydocloading = false;
          });
      }
    },
    getType(url, mimetype, originalname) {
      return getUploadedMediaType({ path: url, mimetype, originalname });
    },
    getMediaPreviewUrl(url, type) {
      return resolveMediaPreviewUrl(url, type);
    },
    onMediaPreviewError(event, file) {
      handleDrivePreviewError(event, file?.url, file?.type);
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    getFileIcon(type) {
      if (type) {
        if (type.toLowerCase() === "image") return "ImageIcon";
        else if (type.toLowerCase() === "video") return "VideoIcon";
        else if (type.toLowerCase() === "pdf") return "FileTextIcon";
        else return "LinkIcon";
      }
      return "LinkIcon";
    },

    hideSideBar() {
      this.visibility = false;
    },
    FillSections() {
      this.currentSections = [];
      // Don't reset secIDs in edit mode as it will clear the selected section
      if (this.myObj.editIDs.length === 0) {
        this.secIDs = [];
      }

      this.classes.forEach((elem) => {
        if (elem.cls.id === this.myObj.homework.cID) {
          if (elem.sections.length != 0) {
            this.currentSections = elem.sections;
            console.log(
              "Sections loaded for class:",
              elem.cls.id,
              "Count:",
              this.currentSections.length,
              "Sections:",
              this.currentSections.map(
                (s) => `ID: ${s.id} (${typeof s.id}) - Name: ${s.section}`
              )
            );
            // this.currentSections.unshift({ section: "All Sections", id: 0 });
          } else {
            console.log("No sections found for class:", elem.cls.id);
            this.currentSections = [];
          }
        }
      });
      console.log("Final currentSections:", this.currentSections);
    },
    setSections() {
      if (!this.secIDs || this.secIDs.length === 0) {
        this.myObj.sections = [];
        return;
      }

      // If in edit mode, handle single section
      if (this.myObj.editIDs.length > 0) {
        // Edit mode - single section, no changes allowed
        this.myObj.sections = [this.currentSectionId];
        this.myObj.homework.section = this.currentSectionId;
        return;
      }

      // Add mode - handle multi-select with "All Sections" logic
      // If "All Sections" (0) is selected
      if (this.secIDs.includes(0)) {
        // If user just selected "All Sections", remove all other selections
        if (
          this.secIDs.length > 1 &&
          this.secIDs[this.secIDs.length - 1] === 0
        ) {
          this.secIDs = [0];
          this.myObj.sections = this.currentSections.map(
            (section) => section.id
          );
        }
        // If user selected a specific section while "All Sections" was already selected, remove "All Sections"
        else if (this.secIDs.length > 1) {
          this.secIDs = this.secIDs.filter((id) => id !== 0);
          this.myObj.sections = this.secIDs;
        }
        // Only "All Sections" is selected
        else {
          this.myObj.sections = this.currentSections.map(
            (section) => section.id
          );
        }
      } else {
        // No "All Sections" selected, keep the selection as is
        this.myObj.sections = this.secIDs;
      }

      // Update homework.section field with first selected section for compatibility
      if (this.myObj.sections.length > 0) {
        this.myObj.homework.section = this.myObj.sections[0];
      }

      // console.log("secIDs:", this.secIDs);
      // console.log("sections:", this.myObj.sections);
    },

    handleEditSectionChange(selectedSectionId) {
      // Update section data for edit mode
      console.log("Section changed to:", selectedSectionId);
      this.currentSectionId = selectedSectionId;
      this.myObj.sections = [selectedSectionId];
      this.myObj.homework.section = selectedSectionId;
      this.secIDs = [selectedSectionId];
    },
    async loadInfo() {
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj);
      // console.log("class", this.classes);
      this.classesOptions = this.classes.map((el) => el.cls);

      var obj2 = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj2);
      // console.log("sub", this.subjects);
    },

    setDate(sd, dateStr) {
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.filterObj.date = date[0];
            this.filterObj.dateTill = date[0];
          } else {
            this.filterObj.date = date[0];
            this.filterObj.dateTill = date[1];
          }
          this.LoadData();
        } else {
          this.filterObj.date = dateStr;
          this.filterObj.dateTill = null;
        }
      } else {
        this.filterObj.date = null;
        this.filterObj.dateTill = null;
      }
    },

    async LoadData() {
      if (!this.filterObj.date) {
        this.$bvToast.toast("Please select the date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      this.dataLoading = true;
      this.selectedIDs = [];
      // GetByClass
      var obj = {
        url:
          this.$store.state.domain +
          "Homework/LoadDataWeb?type=" +
          this.filterObj.type,
        body: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          clsID: this.filterObj.clsID ? this.filterObj.clsID : 0,
          sections: this.filterObj.secID == 0 ? [] : [this.filterObj.secID],
          tID: 0,
          date: this.filterObj.date,
          dateTill: this.filterObj.dateTill || null,
          subjectID: this.filterObj.subjectID,
        },
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      };
      let res = await this.post(obj);
      // console.log("res", res);
      if (Array.isArray(res)) {
        this.items = res;
      } else {
        this.items = [];
      }

      this.dataLoading = false;

      // console.log("hw", this.items);
    },

    async Add(val) {
      this.CheckTitle();
      this.CheckClass();
      this.CheckSubject();
      this.CheckSection();
      this.CheckDate();
      this.checkDetails();
      if (
        this.CheckSection() == false ||
        this.CheckClass() == false ||
        this.CheckSubject() == false ||
        this.checkDetails() == false ||
        this.CheckTitle() == false ||
        this.CheckDate() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (val) {
          this.publishing = true;
          this.myObj.homework.isPublished = true;
        } else {
          this.request = true;
        }
        // console.log("obj:", this.myObj);
        // Don't override sections here as they're already properly set in setSections()
        // this.myObj.sections = this.secIDs;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Homework/Save?userID=" +
            this.$store.state.userData.userID,
          body: this.myObj,
          message: "Homework added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.publishing = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Homework/DeleteHomework?db=" +
            this.$store.state.userData.db +
            "&id=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          body: null,
          message: "Homework removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    async openMessagePopup(homework) {
      this.currentHomework = homework;
      this.messageModal = true;
      this.selectedStudents = [];
      this.studentList = [];
      this.messageText = "";
      this.loadingStudents = true;

      try {
        // Load students based on homework class and section
        const obj = {
          url:
            this.$store.state.domain +
            "students/LoadDataClassWise?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&clsID=" +
            homework.data.cID +
            "&secIDs=" +
            homework.data.sectionID +
            "&gender=All",
          token: this.$store.state.userData.token,
        };
        const res = await this.get(obj);
        this.studentList = res.data || [];
        // this.studentList = (res.data || []).filter(
        //   (el) => el.contact_father || el.contact_mother || el.contact_student
        // );

        // Format message text
        let message = `${homework.data.subject}:\n`;
        message += `This is homework for ${homework.data.clsName}-${homework.data.section}\n\n`;
        message += homework.data.details;

        // Add attachments if any
        if (homework.attachments && homework.attachments.length > 0) {
          message += "\n\nAttachments:\n";
          homework.attachments.forEach((att, index) => {
            message += `${index + 1}. ${att.url}\n`;
          });
        }

        this.messageText = message;
      } catch (error) {
        console.error("Error loading students:", error);
      }
      this.loadingStudents = false;
    },

    dropFilter(opt, label, search) {
      return (
        opt.name.toLowerCase().match(search.toLowerCase()) ||
        opt.grNo.toLowerCase().match(search.toLowerCase()) ||
        opt.father_name.toLowerCase().match(search.toLowerCase())
      );
    },

    async sendMessage() {
      if (this.selectedStudents.length === 0) {
        this.$bvToast.toast("Please select at least one student", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      if (this.messageText.trim() == "") {
        this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.sendingMessage = true;
      try {
        const studentIds = this.selectedStudents.map((s) => s.id);
        let cObj = {
          audio: "",
          media: "",
          message: this.messageText,
          sIDs: studentIds,
          tIDs: [],
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };
        const obj = {
          url:
            this.$store.state.domain +
            "Chat/SendMessageSelected?db=" +
            this.$store.state.userData.db,
          body: cObj,
          message: "WhatsApp messages are being processed.",
          context: this,
          token: this.$store.state.userData.token,
        };

        await this.postObj(obj);
        this.messageModal = false;
      } catch (error) {
        console.error("Error sending message:", error);
      }
      this.sendingMessage = false;
    },

    async openStatus(item) {
      const hwItem = item.data;
      if (hwItem) {
        this.statusListLoading = true;
        this.currentHwID = hwItem.id;
        try {
          const obj = {
            url:
              this.$store.state.domain +
              "HomeworkStatus/LoadData?db=" +
              this.$store.state.userData.db +
              "&hwID=" +
              hwItem.id,
            token: this.$store.state.userData.token,
          };
          const res = await this.get(obj);
          // console.log(res);
          if (Array.isArray(res) && res.length > 0) {
            this.statusList = res.filter((student) => student.homeworkStatus);
            if (this.statusList.length > 0) {
              this.statusHomeworkItem = hwItem;
              this.statusModal = true;
            } else {
              this.$bvToast.toast(this.$t("No records found"), {
                title: this.$t("Info"),
                variant: "info",
                toaster: "b-toaster-top-center",
              });
            }
          } else {
            this.$bvToast.toast(this.$t("No records found"), {
              title: this.$t("Info"),
              variant: "info",
              toaster: "b-toaster-top-center",
            });
          }
        } catch (error) {
          console.error("Error loading homework status:", error);
          this.$bvToast.toast(this.$t("Failed to load homework status"), {
            title: this.$t("Error"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } finally {
          this.statusListLoading = false;
        }
      }
    },
    closeStatusModal() {
      this.statusModal = false;
      this.statusHomeworkItem = null;
      this.statusList = [];
      this.currentHwID = 0;
    },
    async saveHomeworkStatus(sms) {
      if (this.statusList.length === 0) return;
      this.savingStatus = true;
      this.msgSending = sms;
      try {
        const statuses = this.statusList.map(
          (student) => student.homeworkStatus
        );

        const obj = {
          url:
            this.$store.state.domain +
            "HomeworkStatus/Save?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: statuses,
          message: "Homework status updated successfully.",
          context: this,
          token: this.$store.state.userData.token,
        };

        const res = await this.post(obj);

        if (sms) {
          const obj2 = {
            url:
              this.$store.state.domain +
              "HomeworkStatus/SendMessage?db=" +
              this.$store.state.userData.db +
              "&hwID=" +
              this.currentHwID +
              "&userID=" +
              this.$store.state.userData.userID,
            message: "Homework status messages are processed.",
            context: this,
            token: this.$store.state.userData.token,
          };
          const res2 = await this.get(obj2);
        }

        if (res) {
          this.closeStatusModal();
        }
      } catch (error) {
        console.error("Error saving homework status:", error);
        this.$bvToast.toast(this.$t("Failed to save status"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.savingStatus = false;
        this.msgSending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.border-dashed {
  border: 1px solid var(--primary);
  border-style: dashed;
}

.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 80px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
</style>
